/**
 * Created by Daniela on 23/01/2017.
 */
import { Component, OnInit } from '@angular/core';

import { manutencoesRoute} from "../data.service";
import { configuracaoModuleName, configuracaoRoute } from "../../../shared/services/data.service";
import { ordensServicoRoute, ordensServicoModuleName } from "../../ordens-servico/shared/data.service";
import { manutencoesProgramadaModuleName, manutencoesProgramadaRoute } from "../../manutencao-programada/shared/data.service";

@Component({
    selector: 'app-manutencao-menu',
    template: require('./manutencao-menu.component.html')
})
export class ManutencaoMenuComponent implements OnInit {
    manutencoesRoute: string = manutencoesRoute;
    ordensServicoRoute: string = ordensServicoRoute;
    configuracaoRoute: string = configuracaoRoute;
    manutencaoProgramadaRoute: string = manutencoesProgramadaRoute;

    ordensServicoModule: any = ordensServicoModuleName;
    configuracaoModule: any = configuracaoModuleName;
    manutencaoProgramadaModule: any = manutencoesProgramadaModuleName;

    constructor() { }

    ngOnInit() {
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/shared/manutencao-menu/manutencao-menu.component.ts
 **/